import { apiService } from './api';
import { PaymentsResponse, PaymentDto, CreatePaymentRequest, UpdatePaymentRequest } from '../types/payment';
import { PaginationParams } from '../types/common';

class PaymentService {
  async getPayments(params?: PaginationParams & { status?: string; clientId?: string; search?: string; sortBy?: string; sortOrder?: 'asc' | 'desc' }): Promise<PaymentsResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.limit) queryParams.append('limit', String(params.limit));
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.clientId) queryParams.append('clientId', params.clientId);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);

    return apiService.get<PaymentsResponse>(`/payments?${queryParams.toString()}`);
  }

  async getPayment(id: string): Promise<{ payment: PaymentDto }> {
    return apiService.get<{ payment: PaymentDto }>(`/payments/${id}`);
  }

  async createPayment(data: CreatePaymentRequest): Promise<{ message: string; payment: PaymentDto }> {
    return apiService.post<{ message: string; payment: PaymentDto }>(`/payments`, data);
  }

  async updatePayment(id: string, data: UpdatePaymentRequest): Promise<{ message: string; payment: PaymentDto }> {
    return apiService.put<{ message: string; payment: PaymentDto }>(`/payments/${id}`, data);
  }

  async deletePayment(id: string): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(`/payments/${id}`);
  }

  async getStats(params?: { status?: string; clientId?: string; search?: string }): Promise<{ stats: any }> {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.clientId) queryParams.append('clientId', params.clientId);
    if (params?.search) queryParams.append('search', params.search);
    return apiService.get<{ stats: any }>(`/payments/stats?${queryParams.toString()}`);
  }

  async exportPayments(params?: { status?: string; clientId?: string; search?: string }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.clientId) queryParams.append('clientId', params.clientId);
    if (params?.search) queryParams.append('search', params.search);

    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/payments/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const paymentService = new PaymentService();

